// import MainLayout from 'components/layouts/MainLayout';
import DataManageSol from './DataManageSol';
import ReviewTrust from './ReviewTrust';
import OurClient from './OurClient';
import { Banner } from 'components/Header';
import { Helmet } from 'react-helmet';
import { Container, Image } from 'react-bootstrap';
import styles from './landing.module.scss';

function Landing() {
  return (
    <>
      <Helmet>
        <title>Data Management Solutions - CAP60</title>
        <meta
          name="description"
          content="Cap60 is the provider of data management system. One solution for all kinds of data in one place. Contact Now!."
        />
        <meta name="keywords" content="contact us, cap60 contact" />
      </Helmet>
      <Banner />
      <DataManageSol itemsPerRow={5} />
      <Container>
        <section className={styles.mapSection}>
          <div className={styles.heading}>
            <h2 className="text-center mb-4">
              Trusted. Experienced
              <br /> <small>CAP60 network of agencies</small>
            </h2>
          </div>

          <Image
            src="/images/c60map.jpg"
            style={{
              width: '100%',
            }}
          />
          <hr />
          <div className={styles.mapStats}>
            <ul>
              <li>65% Arkansas</li>
              <li>64% Arizona</li>
              <li>63% Kansas</li>
              <li>60% Texas</li>
              <li>50% Minnesota</li>
            </ul>
          </div>
        </section>
      </Container>
      <ReviewTrust />
      <Container>
        <section className={styles.reportSection}>
          <h2 className="text-center mb-4">Agency-wide Reporting</h2>
          <Image
            src="/images/report.jpg"
            style={{
              width: '100%',
            }}
          />
        </section>
      </Container>
      <OurClient />
    </>
  );
}

export default Landing;
